import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { CategoryNodeState } from '@core/models/category.state';

/** Platform taxonomy contract (HLD CAT-03 `PlatformCategory`). */
export interface CategoryRepository {
  tree(): Observable<CategoryNodeState[]>;
  getBySlug(slug: string): Observable<CategoryNodeState | null>;
}

export const CATEGORY_REPOSITORY = new InjectionToken<CategoryRepository>('CATEGORY_REPOSITORY');
